import { AxiosError } from 'axios';
import { useQuery } from 'react-query';
import { EXPRESS_API } from '../../configs/api/expressApi';

interface IGetPromptsLeftCount {
  count: number;
}

export const getPromptsLeftCount = async (): Promise<IGetPromptsLeftCount> => {
  return (await EXPRESS_API.get(`gpt/count`)).data as IGetPromptsLeftCount;
};

export const useGetPromptsLeftCount = () => {
  return useQuery(['MAGIC_COUNT'], () => getPromptsLeftCount(), {
    onError: (err: AxiosError) => console.log(err),
    refetchOnMount: true,
  });
};
